function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.07066 4.93698L9.27466 9.95898H6.95266L4.81066 6.59298L2.79466 9.95898H0.652656L3.85666 5.08098L0.652656 0.0409844H2.97466L5.11666 3.40698L7.13266 0.0409844H9.27466L6.07066 4.93698Z",
  fill: "#FF2828"
});

function SvgNotCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotCheck);
export default __webpack_public_path__ + "static/media/not-check.4cc2bfa6.svg";
export { ForwardRef as ReactComponent };